//
// TODO(blocked-Haim / RND-35692): the real passwordless-OTP endpoints do NOT
// exist yet. These are intentional stubs — they hit no network and DO NOT
// invent the request/response payload. Wire them to hello-server / Chief once
// the OTP contract (send + verify + passwordless-register response shape) is
// published. Gated OFF by default via VITE_PASSWORDLESS_OTP_ENABLED.

/** Sentinel auth token so the flag-on dev flow can advance past this step. */
export const STUB_OTP_AUTH_TOKEN = 'STUB_OTP_TOKEN';

export interface OtpVerifyResult {
  // TODO(blocked-Haim): replace with the real passwordless-register response
  // (auth token + user fields) once the contract is defined.
  authToken: string;
}

/** STUB: would POST { phone } to the OTP send endpoint. */
export async function sendOtp(phone: string): Promise<void> {
  // TODO(blocked-Haim): real send-OTP request.
  console.warn('[otp] sendOtp stub called (no backend yet) for phone ending', phone.slice(-4));
}

/** STUB: would POST { phone, code } and receive a passwordless-register result. */
export async function verifyOtp(_phone: string, code: string): Promise<OtpVerifyResult> {
  // TODO(blocked-Haim): real verify + passwordless register; return real token/user.
  console.warn('[otp] verifyOtp stub called (no backend yet)', { codeLength: code.length });
  return { authToken: STUB_OTP_AUTH_TOKEN };
}
